export default __webpack_public_path__ + "static/media/path-8134-3.2a240807.svg";